import React, {useContext} from 'react';

import WMSMenu from "./WMSMenu";

import {APPLICATIONS} from "utils/Applications";

import {SidebarContext} from "../../../../SidebarContext";
import MarketplaceMenu from "./MarketplaceMenu";
import OMSMenu from "./OMSMenu";

function SidebarMenus(props) {
    const {selectedApplication} = useContext(SidebarContext);

    switch (selectedApplication) {
        case APPLICATIONS.MARKETPLACE:
            return <MarketplaceMenu />;
        case APPLICATIONS.OMS:
            return <OMSMenu />;
        case APPLICATIONS.WMS:
            return <WMSMenu />;
        default:
            return null;
    }
}

export default SidebarMenus;
